module.exports = __webpack_public_path__ + "files/dd290ef6c55d60ea018e4d6814b90061.png";